import React from 'react';
import globe from '../../assets/logo-globe.svg';
import './Footer.scss';

export default class Footer extends React.Component {
  render() {
    return (
      <div className="Footer">
        <p>
          The new Daimler Inclusion<br/>Website Launches soon
        </p>
        <div className="globe">
          <img src={globe} />
        </div>
      </div>
    );
  }
}

